import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../../store/store";

interface InitialState {
    setsNotActive: string[];
}
const initialState: InitialState = {
    setsNotActive: [],
};

const slice = createSlice({
    name: "props-slice",
    initialState,
    reducers: {
        togglePropSet: (state, action: PayloadAction<string>) => {
            if (state.setsNotActive.includes(action.payload)) {
                state.setsNotActive = state.setsNotActive.filter(
                    (p) => p !== action.payload
                );
            } else {
                state.setsNotActive.push(action.payload);
            }
        },
    },
});

export default slice.reducer;

export const { togglePropSet } = slice.actions;

export const selectSetsNotActive = (state: RootState) =>
    state.viewerProps.setsNotActive;
